import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';
import { secureStorage } from '../utils/secureStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// HTTP Status Codes
const HTTP_UNAUTHORIZED = 401;

export const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, {
        email,
        password
      });

      if (response.data.access_token) {
        // Use secure storage with XSS protection
        const tokenSaved = secureStorage.setItem('admin_token', response.data.access_token);
        const emailSaved = secureStorage.setItem('admin_email', email);
        
        if (tokenSaved && emailSaved) {
          toast.success('¡Bienvenido!');
          navigate('/admin/dashboard');
        } else {
          toast.error('Error al guardar la sesión');
        }
      }
    } catch (error) {
      if (error.response?.status === HTTP_UNAUTHORIZED) {
        toast.error('Email o contraseña incorrectos');
      } else {
        toast.error('Error al iniciar sesión');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#152437] flex items-center justify-center px-6">
      <Card className="w-full max-w-md bg-[#111827] border border-white/10 p-8">
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_strategic-studio/artifacts/83cepfxw_Quirofano%20Final%20Variantes-03.svg"
            alt="Quirófano Creativo"
            className="h-12 mx-auto mb-6"
          />
          <h1 className="text-3xl font-light text-white mb-2">
            Panel de <span className="text-[#1aa6b6] font-bold">Administración</span>
          </h1>
          <p className="text-gray-400">Ingresa tus credenciales</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="text-sm text-gray-300 mb-2 block">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@quirofanocreativo.com"
              className="bg-white/5 border-white/10 text-white placeholder:text-gray-500"
            />
          </div>

          <div>
            <label className="text-sm text-gray-300 mb-2 block">Contraseña</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="bg-white/5 border-white/10 text-white placeholder:text-gray-500"
            />
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            className="w-full bg-gradient-to-r from-[#1aa6b6] to-[#6eb9e1] hover:opacity-90 text-white font-medium py-6"
          >
            {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-gray-400 hover:text-[#1aa6b6] transition-colors"
          >
            ← Volver al sitio
          </button>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;
